export function getFunctionsHost() {
  if (window.location.hostname.includes("localhost")) {
    return "http://localhost:5001/run4lives/us-central1/";
  }
  if (window.location.hostname.includes("127.0.0.1")) {
    return "http://127.0.0.1:5001/run4lives/us-central1/";
  }
  return "https://us-central1-run4lives.cloudfunctions.net/";
}
